import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for dashboard hooks
 * Keys match backend controller method names
 */
export const dashboardKeys = {
  getOverview: () => ["dashboard", "getOverview"] as const,
  getRecentActivity: (params?: QueryParamsDto) =>
    params
      ? (["dashboard", "getRecentActivity", params] as const)
      : (["dashboard", "getRecentActivity"] as const),
  getCalendar: (params: { from: string; to: string }) =>
    ["dashboard", "getCalendar", params] as const,
} as const
